
    var riot = require('riot')
    //src: starling/src/tags/menu/buttons/menu-button-edit-region-shape.html
riot.tag2('menu-button-edit-region-shape',
  '<svg class="bulk-actions-menu-item_icon"> <use xlink:href="#format-shapes-icon"></use> </svg> <svg class="bulk-actions-menu-item_arrow"> <use xlink:href="#caret-menu-icon"></use> </svg>',
  '',
  'class="bulk-actions-menu-item {bulk-actions-menu-item--active: isMenuOpen}" data-tip="Region shape" onclick="{toggleShapePicker}"', function(opts) {
'use strict';

var _this = this;

var _menuUi = require('lib/menu-ui');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _opts = opts,
    canvas = _opts.canvas;

_menuUi.mui.registerMenuButton(this, 'editRegionShape');

this.toggleShapePicker = function () {
  var regionShapeMenu = canvas.regionShapeMenu;
  var parent = _this.parent,
      root = _this.root;

  if (_this.isMenuOpen) {
    _this.isMenuOpen = false;
    root.removeAttribute('data-tip-hide');
    parent.unsetActiveTool(root);
    regionShapeMenu.close();
    _eventTracking2.default.track({
      category: 'Toolbar',
      action: 'Close-Region-Shape-Menu',
      label: 'Close'
    });
  } else {
    _this.isMenuOpen = true;
    root.setAttribute('data-tip-hide', 'true');
    parent.setActiveTool(root);
    regionShapeMenu.summon({ referenceTag: _this, position: 'below' });
    _eventTracking2.default.track({
      category: 'Toolbar',
      action: 'Open-Region-Shape-Menu',
      label: 'Open'
    });
  }
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-button-edit-region-shape')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/buttons/menu-button-edit-region-shape.html
// module id = 757
// module chunks = 0